import { render, staticRenderFns } from "./temp4.vue?vue&type=template&id=31e84646&scoped=true&"
import script from "./temp4.vue?vue&type=script&lang=js&"
export * from "./temp4.vue?vue&type=script&lang=js&"
import style0 from "./temp4.vue?vue&type=style&index=0&id=31e84646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e84646",
  null
  
)

export default component.exports